import {useEffect} from 'react';
import {usePersistentStore} from 'stores';

const ONE_MINUTE = 2 * 60 * 1000;

const useGetCountry = () => {
  const staleTime = usePersistentStore(s => s.countryCode.staleTime);
  const setCountryCode = usePersistentStore(s => s.setCountryCode);

  useEffect(() => {
    if (staleTime && new Date() < new Date(staleTime)) {
      return;
    }
    (async () => {
      try {
        const ip = await fetch('https://ipapi.co/json');
        const parsed = await ip.json();
        const future = new Date(new Date().getTime() + ONE_MINUTE);
        const newCountryCode = {code: parsed.country_code, staleTime: future};
        setCountryCode(newCountryCode);
      } catch (err: any) {
        setCountryCode({code: 'MY', staleTime: null});
        console.error('IP service error');
      }
    })();
  }, [staleTime, setCountryCode]);
};

export default useGetCountry;
